// Seeks the recording player to a throughput point's video position on click,
// dispatching the same DOM events the Appium "Jump to video" button uses. A
// no-op when no target element or per-point offsets are provided.
export function videoSeek({ ptsSeconds, target }) {
  let idx = null;
  let onClick = null;

  function init(u) {
    if (!target || !Array.isArray(ptsSeconds)) return;

    onClick = () => {
      const seconds = idx == null ? null : ptsSeconds[idx];
      if (seconds == null) return;

      const el = document.getElementById(target);
      if (!el) return;

      el.dispatchEvent(new CustomEvent("set-video-time", { detail: { time: seconds } }));
      el.dispatchEvent(new CustomEvent("scroll-to-video"));
    };

    u.over.addEventListener("click", onClick);
    u.over.style.cursor = "pointer";
  }

  function destroy(u) {
    if (onClick) u.over.removeEventListener("click", onClick);
  }

  function setLegend(u) {
    idx = u.cursor.idx ?? null;
  }

  return { hooks: { init, destroy, setLegend } };
}
